var map = {
  "./action.svg": "67383",
  "./address.svg": "21693",
  "./all-forms-legacy.svg": "68234",
  "./all-forms.svg": "88528",
  "./api.svg": "32717",
  "./approvals.svg": "89629",
  "./archive-open.svg": "5256",
  "./archive.svg": "63011",
  "./arrow-left.svg": "47920",
  "./arrow-right.svg": "2203",
  "./attachments.svg": "52487",
  "./audit-log.svg": "47905",
  "./automation.svg": "54666",
  "./ban.svg": "82940",
  "./bank.svg": "96515",
  "./bold.svg": "20246",
  "./bug-fix.svg": "31925",
  "./build.svg": "63709",
  "./bulk-actions.svg": "40955",
  "./calculations.svg": "99523",
  "./center.svg": "98660",
  "./check-circle.svg": "62642",
  "./check.svg": "93173",
  "./chevron-down.svg": "64687",
  "./chevron-left.svg": "34034",
  "./chevron-right.svg": "5189",
  "./chevron-up.svg": "16914",
  "./choice.svg": "72542",
  "./circle.svg": "93609",
  "./clear-fields.svg": "46480",
  "./cog.svg": "94138",
  "./cognibot.svg": "91146",
  "./collapse-menu.svg": "94780",
  "./columns.svg": "66622",
  "./contact-person.svg": "13619",
  "./continue-workflow.svg": "13452",
  "./copy.svg": "17760",
  "./create-document.svg": "53507",
  "./create-entries.svg": "83828",
  "./credit-card.svg": "43723",
  "./currency.svg": "63150",
  "./cut.svg": "11565",
  "./data.svg": "83045",
  "./date.svg": "1113",
  "./delta-decrease.svg": "87184",
  "./delta-increase.svg": "11932",
  "./document-signing.svg": "38966",
  "./document.svg": "56052",
  "./double-chevron-left.svg": "19570",
  "./double-chevron-right.svg": "71493",
  "./download.svg": "37549",
  "./drag-handle-dot.svg": "33188",
  "./drag-handle.svg": "17454",
  "./edit-profile.svg": "88473",
  "./edit-square.svg": "54137",
  "./edit.svg": "70601",
  "./ellipsis.svg": "2822",
  "./email.svg": "73925",
  "./entries.svg": "19421",
  "./error.svg": "79899",
  "./ex-outline.svg": "98835",
  "./ex.svg": "51432",
  "./external-link.svg": "71147",
  "./eye.svg": "18392",
  "./facebook.svg": "75961",
  "./field-above.svg": "84277",
  "./field-below.svg": "29669",
  "./field-left.svg": "26279",
  "./field-right.svg": "26514",
  "./filter.svg": "15727",
  "./flask.svg": "14402",
  "./floating.svg": "97979",
  "./folder.svg": "59625",
  "./form-view.svg": "16753",
  "./form.svg": "78011",
  "./generated-documents.svg": "59263",
  "./github.svg": "98938",
  "./give-access.svg": "58779",
  "./grid.svg": "37805",
  "./guest-person.svg": "33975",
  "./hamburger.svg": "76882",
  "./home.svg": "80978",
  "./hr.svg": "81075",
  "./id.svg": "86944",
  "./identify-submitter.svg": "18643",
  "./image.svg": "18976",
  "./import-form.svg": "68267",
  "./indent.svg": "64683",
  "./infinity.svg": "35801",
  "./info.svg": "74849",
  "./instagram.svg": "21321",
  "./internal.svg": "29228",
  "./italic.svg": "58173",
  "./justify-field.svg": "24860",
  "./justify.svg": "84853",
  "./left.svg": "37868",
  "./light-bulb.svg": "18029",
  "./limited-availability.svg": "70659",
  "./link.svg": "74765",
  "./linkedin.svg": "41775",
  "./loading.svg": "11713",
  "./lock.svg": "52930",
  "./login.svg": "44752",
  "./logout.svg": "52235",
  "./lookup.svg": "95147",
  "./minus-square.svg": "74117",
  "./mobile-phone.svg": "32250",
  "./mouse-click.svg": "3583",
  "./multiple-emails.svg": "53411",
  "./name.svg": "8518",
  "./no-eye.svg": "57258",
  "./number.svg": "99964",
  "./ol.svg": "36934",
  "./open-folder.svg": "49838",
  "./organization.svg": "26906",
  "./outdent.svg": "79672",
  "./page-break.svg": "76356",
  "./paste.svg": "94254",
  "./pdf.svg": "53699",
  "./pending.svg": "81422",
  "./person-form-new.svg": "95384",
  "./person-form.svg": "58835",
  "./person.svg": "21640",
  "./phone.svg": "72897",
  "./pin.svg": "16362",
  "./plus-square.svg": "67133",
  "./plus.svg": "58717",
  "./preview.svg": "58409",
  "./price.svg": "2384",
  "./print.svg": "11266",
  "./public-link-disabled.svg": "9438",
  "./public-link.svg": "13833",
  "./public.svg": "28732",
  "./rating-scale.svg": "74295",
  "./read-unread.svg": "37149",
  "./recent.svg": "19118",
  "./refund.svg": "79215",
  "./register.svg": "71252",
  "./repeating-section.svg": "48654",
  "./reset.svg": "95866",
  "./resize.svg": "2037",
  "./retrying.svg": "91667",
  "./right.svg": "15071",
  "./role.svg": "26189",
  "./save-resume.svg": "43430",
  "./save.svg": "11744",
  "./search.svg": "91265",
  "./section.svg": "67154",
  "./sending.svg": "37119",
  "./settings.svg": "73456",
  "./share-role.svg": "44559",
  "./share.svg": "7790",
  "./shared-template.svg": "21751",
  "./sidebar.svg": "69545",
  "./signature.svg": "59079",
  "./sort-down.svg": "43226",
  "./sort-up.svg": "1035",
  "./sort.svg": "92481",
  "./spark.svg": "45680",
  "./spreadsheet-spark.svg": "92335",
  "./star-outline.svg": "61942",
  "./star.svg": "44381",
  "./status-ring.svg": "20966",
  "./stop-sign.svg": "60391",
  "./style-body.svg": "82006",
  "./style-header.svg": "23456",
  "./style-page.svg": "32070",
  "./success.svg": "31878",
  "./support.svg": "27842",
  "./sync.svg": "60446",
  "./table.svg": "79049",
  "./task-grid.svg": "15717",
  "./tasks.svg": "97199",
  "./templates.svg": "61598",
  "./textbox.svg": "65157",
  "./theme.svg": "78376",
  "./time.svg": "13828",
  "./trash.svg": "22695",
  "./ul.svg": "70724",
  "./underline.svg": "26225",
  "./unlock.svg": "84993",
  "./unpin.svg": "73783",
  "./upload.svg": "22812",
  "./user-person.svg": "86226",
  "./users.svg": "61965",
  "./video.svg": "78022",
  "./warning.svg": "42481",
  "./watch.svg": "77486",
  "./webhooks.svg": "82075",
  "./word.svg": "29965",
  "./workflow.svg": "7072",
  "./x.svg": "30309",
  "./yes-no.svg": "11660",
  "./youtube.svg": "41868"
};


function __rspack_context_module(req) {
  var id = __rspack_context_module_resolve(req);
  return __webpack_require__(id);
}
function __rspack_context_module_resolve(req) {
  if(!__webpack_require__.o(map, req)) {
    var e = new Error("Cannot find module '" + req + "'");
    e.code = 'MODULE_NOT_FOUND';
    throw e;
  }
  return map[req];
}
__rspack_context_module.keys = () => (Object.keys(map));
__rspack_context_module.resolve = __rspack_context_module_resolve;
module.exports = __rspack_context_module;
__rspack_context_module.id = 53899;
